<app-page-header title="Provider Login Info" subtitle="Manage PSP provider login credentials">
    <div actions class="flex gap-2">
        <p-iconfield>
            <p-inputicon class="pi pi-search" />
            <input type="text" pInputText placeholder="Search" (input)="onGlobalSearch($event)" />
        </p-iconfield>
        <p-button label="Add New" (click)="openCreate()" icon="pi pi-plus"></p-button>
    </div>
</app-page-header>

<div class="table-card">
    <p-confirmpopup />
    <p-table
        #dt
        [value]="loginInfoList"
        [loading]="loading"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50]"
        [scrollable]="true"
        scrollHeight="flex"
        dataKey="id"
        [rowHover]="true"
        [globalFilterFields]="['pspType', 'deepLink', 'userName', 'additionalInfo']"
    >
        <ng-template #header>
            <tr>
                <th pSortableColumn="id" class="text-left w-[80px]">
                    <div class="flex items-center gap-2">
                        ID
                        <p-sortIcon field="id"></p-sortIcon>
                    </div>
                </th>
                <th pSortableColumn="pspType" class="text-left">
                    <div class="flex items-center gap-2">
                        PSP Type
                        <p-sortIcon field="pspType"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="pspType" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="deepLink" class="text-left">
                    <div class="flex items-center gap-2">
                        Deep Link
                        <p-sortIcon field="deepLink"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="deepLink" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="userName" class="text-left">
                    <div class="flex items-center gap-2">
                        User Name
                        <p-sortIcon field="userName"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="userName" display="menu"></app-column-filter>
                    </div>
                </th>
                <th class="text-left">Password</th>
                <th pSortableColumn="additionalInfo" class="text-left">
                    <div class="flex items-center gap-2">
                        Additional Info
                        <p-sortIcon field="additionalInfo"></p-sortIcon>
                    </div>
                </th>
                <th class="w-[120px]"></th>
            </tr>
        </ng-template>
        <ng-template #body let-row>
            <tr>
                <td>{{ row.id }}</td>
                <td>{{ row.pspType }}</td>
                <td>{{ row.deepLink }}</td>
                <td>{{ row.userName }}</td>
                <td>{{ row.password }}</td>
                <td>{{ row.additionalInfo }}</td>
                <td class="text-right">
                    <div class="flex gap-2 justify-end">
                        <p-button [text]="true" severity="secondary" icon="pi pi-pencil" (click)="openEdit(row)"></p-button>
                        <p-button [text]="true" severity="danger" icon="pi pi-trash" (click)="confirmDelete($event, row)"></p-button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-dialog
    [header]="isEditMode ? 'Edit Login Info' : 'New Login Info'"
    [(visible)]="dialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '500px' }"
>
    <form [formGroup]="loginForm" (ngSubmit)="saveLoginInfo()">
        <div class="flex flex-col gap-4">
            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">PSP Type *</label>
                <p-select
                    [options]="pspTypes"
                    formControlName="pspId"
                    optionLabel="text"
                    optionValue="id"
                    placeholder="Select PSP type"
                    [filter]="true"
                    filterBy="text"
                    appendTo="body"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('pspId') }"
                ></p-select>
                @if (isInvalid('pspId')) {
                    <small class="text-red-500">PSP type is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Deep Link *</label>
                <input
                    type="text"
                    pInputText
                    placeholder="Enter deep link URL"
                    formControlName="deepLink"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('deepLink') }"
                />
                @if (isInvalid('deepLink')) {
                    <small class="text-red-500">Deep link is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">User Name *</label>
                <input
                    type="text"
                    pInputText
                    placeholder="Enter user name"
                    formControlName="userName"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('userName') }"
                />
                @if (isInvalid('userName')) {
                    <small class="text-red-500">User name is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Password *</label>
                <input
                    type="password"
                    pInputText
                    placeholder="Enter password"
                    formControlName="password"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('password') }"
                />
                @if (isInvalid('password')) {
                    <small class="text-red-500">Password is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Additional Info</label>
                <input type="text" pInputText placeholder="Enter additional info" formControlName="additionalInfo" />
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" variant="outlined" (click)="cancelDialog()"></p-button>
            <p-button [label]="isEditMode ? 'Update' : 'Create'" (click)="saveLoginInfo()"></p-button>
        </div>
    </ng-template>
</p-dialog>
